import { render, staticRenderFns } from "./ManageClients.vue?vue&type=template&id=2197b035"
import script from "./ManageClients.vue?vue&type=script&lang=js"
export * from "./ManageClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports